import React, { useState } from "react";
import { Button } from "./ui/button";
import { Label } from "./ui/label";
import { MONTHS_HI, getTimings, saveTimings, fmt12 } from "../data/rssbData";
import { toast } from "sonner";
import { Clock, Save } from "lucide-react";

const ROWS = [
  ["sun", "रविवार (सुबह)"],
  ["wed", "बुधवार (सुबह)"],
  ["thu", "गुरुवार (सुबह)"],
  ["noon", "विशेष SK दोपहर सत्संग"],
];

// Season-wise satsang timings: pick summer months, set summer & winter times.
export const TimingCard = () => {
  const [t, setT] = useState(getTimings);
  const toggleMonth = (m) =>
    setT((s) => ({ ...s, summerMonths: s.summerMonths.includes(m) ? s.summerMonths.filter((x) => x !== m) : [...s.summerMonths, m].sort((a, b) => a - b) }));
  const setTime = (season, k, v) => setT((s) => ({ ...s, [season]: { ...s[season], [k]: v } }));
  const save = () => {
    saveTimings(t);
    toast.success("सत्संग समय सहेजा गया — सभी शेड्यूल, PDF, Excel व स्लिप में लागू");
  };
  return (
    <div className="bg-[#fffdf7] border border-[#e3d6b6] rounded-xl p-4 space-y-3" data-testid="timing-card">
      <h3 className="font-serif-dev font-semibold text-[#3a1212] flex items-center gap-2">
        <Clock className="w-4 h-4 text-[#6e1b1b]" /> सत्संग समय (मौसम अनुसार)
      </h3>
      <div>
        <Label className="text-xs text-[#5a2a24]">गर्मी के महीने (बाकी महीने सर्दी)</Label>
        <div className="flex flex-wrap gap-1.5 mt-1">
          {MONTHS_HI.map((m, i) => (
            <button
              type="button"
              key={m}
              data-testid={`summer-month-${i}`}
              onClick={() => toggleMonth(i)}
              className={`px-2.5 py-1 rounded-full text-xs font-dev border transition-colors ${
                t.summerMonths.includes(i) ? "bg-[#b45309] text-white border-[#92400e]" : "bg-[#e8eef8] text-[#1e3a5f] border-[#c5d3e8]"
              }`}
            >
              {m}
            </button>
          ))}
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm font-dev">
          <thead>
            <tr className="text-[#5a2a24] text-xs">
              <th className="text-left py-1">सत्संग</th>
              <th className="py-1">गर्मी</th>
              <th className="py-1">सर्दी</th>
            </tr>
          </thead>
          <tbody>
            {ROWS.map(([k, label]) => (
              <tr key={k} className="border-t border-[#e3d6b6]">
                <td className="py-1.5 pr-2 text-[#3a1212]">{label}</td>
                {["summer", "winter"].map((season) => (
                  <td key={season} className="py-1.5 px-1 text-center">
                    <input
                      type="time"
                      data-testid={`time-${season}-${k}`}
                      value={t[season][k]}
                      onChange={(e) => setTime(season, k, e.target.value)}
                      className="bg-[#f6eeda] border border-[#e3d6b6] rounded-md px-2 py-1 text-sm"
                    />
                    <div className="text-[10px] text-[#9a7a5a]">{fmt12(t[season][k])}</div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Button data-testid="timing-save" onClick={save} className="bg-[#6e1b1b] text-[#f3ead6] hover:bg-[#7a1f1f] gap-1">
        <Save className="w-4 h-4" /> समय सहेजें
      </Button>
    </div>
  );
};
